import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const branchOfficeList = createAsyncThunk('branchOfficeList', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `branch_office`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                ...(data?.instituteId ? { institute_id: data.instituteId } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const branchOfficeListSlice = createSlice({
    name: 'branchOfficeList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(branchOfficeList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = (() => {
                    const raw = action.payload?.data?.data;
                    if (Array.isArray(raw)) return raw;
                    if (Array.isArray(raw?.getBranchOfficeList)) return raw.getBranchOfficeList;
                    if (Array.isArray(raw?.branchOfficeList)) return raw.branchOfficeList;
                    if (Array.isArray(raw?.branch_office)) return raw.branch_office;
                    return Object.values(raw || {}).find(Array.isArray) || [];
                })();
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(branchOfficeList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default branchOfficeListSlice.reducer;
